"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIMPLE_YES_NO = void 0;
var SIMPLE_YES_NO = exports.SIMPLE_YES_NO = [{
  label: 'Yes',
  value: 'yes'
}, {
  label: 'No',
  value: 'no'
}];